var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.264,
    height: 24.795,
    viewBox: "0 0 35.264 24.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M35.577,8.38A4.431,4.431,0,0,0,32.46,5.242C29.709,4.5,18.682,4.5,18.682,4.5S7.655,4.5,4.9,5.242A4.431,4.431,0,0,0,1.787,8.38a46.482,46.482,0,0,0-.737,8.543,46.482,46.482,0,0,0,.737,8.543A4.365,4.365,0,0,0,4.9,28.553c2.75.742,13.777.742,13.777.742s11.027,0,13.777-.742a4.365,4.365,0,0,0,3.118-3.088,46.482,46.482,0,0,0,.737-8.543,46.482,46.482,0,0,0-.737-8.543Zm-20.5,13.786V11.679l9.217,5.243-9.217,5.243Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#2eafbe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.f98bd38d1699c21c2841a329d9bbabde.svg";
export { ForwardRef as ReactComponent };